/**
 * DatabricksImportPage — full-page Databricks import (v2.0 demo-path beat 1).
 *
 * Replaces the Home → "Import from Databricks" modal with the One Compass
 * full-page layout from docs/design/prototypes/01-databricks-import.html:
 * editorial eyebrow/headline/subhead over the cream ground, with the journey
 * creation form (Databricks-only) hosted inline via its `variant="page"` mode.
 *
 * All create/analyze logic stays in JourneyCreationForm — this page is chrome.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { JourneyCreationForm, type ReanalyzePrefill } from '../../components/JourneyCreationForm';
import './databricks-import.css';

export const DatabricksImportPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // A dataset re-analysis routes here with the saved source pre-resolved; the
  // form then auto-runs the same analysis the first analysis runs (identical
  // staged overlay) instead of showing the Unity Catalog browse step.
  const reanalyze = (location.state as { reanalyze?: ReanalyzePrefill } | null)?.reanalyze;

  return (
    <div className="dbx-import-page">
      <div className="dbx-import-inner">
        <button
          type="button"
          className="dbx-import-back"
          onClick={() => navigate('/home')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Home
        </button>

        <div className="dbx-import-eyebrow">Integrations &middot; Databricks</div>
        <h1 className="dbx-import-headline">
          {reanalyze ? 'Re-analyzing your dataset' : 'Import from Databricks'}
        </h1>
        <p className="dbx-import-subhead">
          {reanalyze
            ? `Re-running the full analysis on ${reanalyze.catalog}.${reanalyze.schema}.${reanalyze.table} — no need to re-browse.`
            : 'Browse Unity Catalog, pick a table, preview the data, and name the analysis.'}
        </p>

        <JourneyCreationForm
          isOpen
          variant="page"
          forceDataSource="databricks"
          reanalyzePrefill={reanalyze}
          onClose={() => navigate('/home')}
          onSuccess={(groupId) => navigate(`/journey/${groupId}`)}
        />
      </div>
    </div>
  );
};

export default DatabricksImportPage;
